"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var cookiePopupThemes = {
  Light: {
    container: "\n      background: white;\n    ",
    button: "\n      background-color: #000;\n      color: #FFF;\n    "
  },
  Dark: {
    container: "\n      background: black;\n      color: #FFF;\n    ",
    button: "\n      background-color: #FFFC00;\n      color: #000;\n      font-weight: bold;\n    "
  }
};
var _default = cookiePopupThemes;
exports["default"] = _default;